import useSWR from 'swr'
import api from 'utils/api'
import { browserTime } from 'utils/time'

export const useAdminData = url => useSWR(url, api.get, { shouldRetryOnError: false, revalidateOnFocus: false })
export const timestamp = value => value && browserTime(value).isValid() ? browserTime(value).format('MM/DD/YYYY HH:mm') : '—'
export const operationKey = () => window.crypto.randomUUID()
export const errorMessage = error => `${error?.message || 'The request could not be completed.'}${error?.businessIds?.length ? ` Businesses requiring closure: ${error.businessIds.join(', ')}.` : ''}`
